import { EntityRepository, Repository } from "typeorm";
import { AssignRejections } from "./assign-rejections.entity";

@EntityRepository(AssignRejections)
export class AssignRejectionRepository extends Repository<AssignRejections> {
    
}